const toNumber = (value) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const roundMoney = (value) =>
  Math.round((toNumber(value) + Number.EPSILON) * 100) / 100;

const normalizedDiscountType = (value) => {
  if (value === "%") return "Percentage";
  return value || "None";
};

export const calculateInvoiceLine = (item, gstType = "Inclusive") => {
  const quantity = Math.max(0, toNumber(item.itemQuantity));
  const unitPrice = Math.max(0, toNumber(item.itemPrice));
  const taxRate = gstType === "No GST" ? 0 : Math.max(0, toNumber(item.gst));
  const discountType = normalizedDiscountType(item.discountType);
  const discountValue = Math.max(0, toNumber(item.discountValue));
  const grossInput = roundMoney(unitPrice * quantity);
  const inputDiscount = Math.min(
    grossInput,
    discountType === "Percentage"
      ? roundMoney((grossInput * Math.min(discountValue, 100)) / 100)
      : discountType === "Fixed"
      ? roundMoney(discountValue)
      : 0
  );

  const isInclusive = gstType !== "Exclusive";
  const totalInclusive = Math.max(0, roundMoney(grossInput - inputDiscount));
  const gstAmount = roundMoney(
    isInclusive
      ? (totalInclusive * taxRate) / (100 + taxRate)
      : (totalInclusive * taxRate) / 100
  );
  const subtotalExcludingGst = isInclusive
    ? roundMoney(
        grossInput - roundMoney((grossInput * taxRate) / (100 + taxRate))
      )
    : grossInput;
  const netExcludingGst = isInclusive
    ? roundMoney(totalInclusive - gstAmount)
    : totalInclusive;
  const discountAmount = roundMoney(subtotalExcludingGst - netExcludingGst);
  const totalItemPrice = isInclusive
    ? totalInclusive
    : roundMoney(netExcludingGst + gstAmount);

  return {
    ...item,
    discountType,
    discountAmount,
    totalItemPrice,
    subtotalExcludingGst,
    gstAmount,
  };
};

export const calculateInvoiceTotals = (items = [], gstType = "Inclusive") => {
  const calculatedItems = items.map((item) =>
    calculateInvoiceLine(item, gstType)
  );
  const totals = calculatedItems.reduce(
    (result, item) => ({
      totalAmount: result.totalAmount + item.subtotalExcludingGst,
      totalDiscountAmount: result.totalDiscountAmount + item.discountAmount,
      totalGSTAmount: result.totalGSTAmount + item.gstAmount,
      finalAmount: result.finalAmount + item.totalItemPrice,
    }),
    {
      totalAmount: 0,
      totalDiscountAmount: 0,
      totalGSTAmount: 0,
      finalAmount: 0,
    }
  );

  return {
    items: calculatedItems,
    totalAmount: roundMoney(totals.totalAmount),
    totalDiscountAmount: roundMoney(totals.totalDiscountAmount),
    totalGSTAmount: roundMoney(totals.totalGSTAmount),
    finalAmount: roundMoney(totals.finalAmount),
  };
};
